<template>
    <v-container>
      <v-row>
        <v-col md="12" class="pa-6 text-left text-justify">
          <div class="my-6">
            <p class="text-h4 text--primary">
                <TextHeading :level=3>Szkolenia zamknięte</TextHeading>
            </p>
            <div class="text-body-1 text--primary">
                Szkolenia o charakterze zamkniętym są dostosowane do indywidualnych potrzeb naszych Klientów, dlatego też często zakres merytoryczny oraz szczegółowość szkolenia poprzedzone są analizą mającą charakter ankiety lub wywiadu. Realizujemy szkolenia w formie stacjonarnej i zdalnej.
            </div>
            <br />
            <div class="text-body-1 text--primary">
                Oferujemy szkolenia z zakresu:
            </div>
            <v-list dense disabled>
                <v-list-item
                    v-for="(item, i) in range"
                    :key="i"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-title class="text-body-1 text--primary text-wrap font-weight-regular">{{ item.text }}</v-list-item-title>
                </v-list-item>
            </v-list>
            <div class="text-body-1 text--primary">
                Koszt szkolenia uzależniony jest od liczby uczestników:
            </div>
            <v-simple-table>
                <thead>
                <tr>
                    <th class="text-left text-body-1 text--primary">
                    Liczba uczestników
                    </th>
                    <th class="text-left text-body-1 text--primary">
                    Cena netto za grupę
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in prices"
                    :key="index"
                >
                    <td class="text-body-1 text--primary">{{ item.numbers }}</td>
                    <td class="text-body-1 text--primary">{{ item.price }}</td>
                </tr>
                </tbody>
            </v-simple-table>
            <div class="text-body-1 text--primary">
                W przypadku jakichkolwiek pytań zachęcamy do kontaktu: <router-link class="nav-link" to="/contact">Kontakt</router-link>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </template>
  <script>
  import TextHeading from "@/modules/TextHeading";
  export default {
  
    components: {TextHeading},

    data: () => ({
        prices: [
            {
                numbers: "Do 5 osób",
                price: "3 000,00 zł"
            },
            {
                numbers: "Od 6 do 10 osób",
                price: "5 000,00 zł"
            },
            {
                numbers: "Od 10 do 15 osób",
                price: "6 500,00 zł"
            },
        ],
        range: [
            {
                text: 'Kwalifikowalności wydatków w projektach współfinansowanych ze środków UE;',
                icon: "mdi-circle-medium"
            },
            {
                text: 'Udzielanie zamówień w projektach współfinansowanych ze środków UE, w tym w oparciu o Prawo zamówień publicznych i Zasadę konkurencyjności;',
                icon: "mdi-circle-medium"
            },
            {
                text: 'Budżetowanie projektów współfinansowanych ze środków UE;',
                icon: "mdi-circle-medium"
            },
            {
                text: 'Rozliczanie projektów współfinansowanych ze środków UE - obsługa systemu SL2014;',
                icon: "mdi-circle-medium"
            },
            {
                text: 'Kontroli projektów współfinansowanych ze środków UE;',
                icon: "mdi-circle-medium"
            },
        ],
    })
  }
  </script>